module.exports = __webpack_public_path__ + "img/allgrads_logo2.be11d543.png";